export const extractTypeMark = (settings?: string | null): string => {
    if (!settings) return '';

    try {
        const parsedSettings = JSON.parse(settings);
        if (!Array.isArray(parsedSettings)) return '';

        return parsedSettings.find((setting: any) => setting?.name === 'Type Mark')?.value ?? '';
    } catch {
        return '';
    }
};